<template>
  <dialog-email
    ref="dialog-email"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="data"
    :isLoading="isLoading"
    @on-submit-email="handlerSubmit"
  />
</template>

<script>
import { toDate } from '@/utils/filters'
import { createList } from '@/utils/templates'
import { createParams } from '@/utils/dynamic'
import { ModelEmailNewInstruction } from '@/models/RepairExchangeOrder'
import { api } from '@/services/api'
import { ServiceEmailMessages } from '@/services/email-messages'
import { ServiceCustomerPOFollowUp } from '@/services/CustomerPOFollowUp'

export default {
  name: 'DialogNewInstructionCustomer',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      isLoading: false,
      id: null,
      subject: null,
      requestMainData: null,
      requestLogData: null,
      data: {},
      contentMap: {},
      cb: () => {}
    }
  },
  created () {
    this.$bus.$on('on-new-instruction-customer', this.show)
  },
  beforeDestroy () {
    this.$bus.$off('on-new-instruction-customer', this.show)
  },
  computed: {
    contentKey () {
      return 'instruction-to-support'
    }
  },
  methods: {
    loadData () {
      this.isLoading = true
      return Promise.all([
        this.loadMainData(),
        this.loadLogData()
      ])
        .then(() => {
          this.createMapData()
          this.createEmailData()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async loadMainData () {
      const params = createParams({
        select: [
          'id', 'po', 'part.partNumber as partNumber', 'partSN', 'lastInfo',
          'rfq3.rfq.customerContact.name as customerContactName', 'rfq3.rfq.customerContact.email as customerContactEmail',
          'new { employee.name, employee.contact.email  } as employee'
        ].join(','),
        filter: `id == ${this.id}`
      })

      const { data } = await ServiceCustomerPOFollowUp.getDynamic(this.id, params)

      this.requestMainData = data
    },
    loadLogData () {
      const params = createParams({
        select: 'id,entryDate,employeeID,description,isEmployeeEntry,isRead,employee.name as employeeName',
        filter: `customerPOFollowUpID == ${this.id}`,
        orderBy: `id desc`
      })
      return api
        .get(`CustomerPOFollowUpLogs/GetAllDynamic`, { params })
        .then(({ data }) => {
          this.requestLogData = data.value
            .map((logItem) => {
              return {
                ...logItem,
                entryDate: toDate(logItem.entryDate)
              }
            })
        })
    },
    createMapData () {
      this.contentMap = this.copyObjectProps(new ModelEmailNewInstruction(), {
        ...this.requestMainData,
        subject: this.subject,
        listActivities: createList(this.requestLogData, '{employeeName}, {entryDate}, {description}')
      })
    },
    createEmailData () {
      const { po, employee } = this.requestMainData
      let subject = `${this.L10n('order-followup-email-subject')}: ${po}`
      let emailToList = ['support@bel-airexpress.com', 'logistics@bel-airexpress.com', employee.email].filter(Boolean)

      this.data = {
        subject,
        emailToList
      }
    },
    show ({ subject, id }, cb) {
      this.cb = cb
      this.id = id
      this.subject = subject
      this.$refs['dialog-email'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog-email'].hide()
      this.isLoading = false
    },
    handlerSubmit (data) {
      this.isLoading = true
      ServiceEmailMessages.send(data)
        .then(() => {
          if (typeof this.cb === 'function') {
            this.cb({ ...data, customerContactName: this.requestMainData.customerContactName })
          }
          this.hide()
        })
        .catch((err) => {
          this.isLoading = false
          this.requestErrorHandler(err)
        })
    }
  }
}
</script>
